import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import { columns } from './columns'

export const QuietHoursTable = observer(() => {
  const store = useContext(DoubleOptInPageContext)

  if (!store || !store.quietHoursStore) return null

  return (
    <Table
      ariaLabel={'QuietHoursTable'}
      store={store.quietHoursStore.tableStore}
      columns={columns}
      rows={store.quietHoursStore.rows}
      hidePagination
      sxTable={{ marginBottom: '32px' }}
      scrollbarProps={{
        autoHeight: true,
        height: 'auto',
        autoHeightMax: 600,
      }}
    />
  )
})
